<template>
    <div class="pay_fail full">
        <!-- <tabbar msg="订单完成"></tabbar> -->
        <img :src="$store.state.api.imgUrl + 'buy_fail.png'" alt="" class="img">
        <img :src="$store.state.api.imgUrl + 'buy_fail_text.png'" alt="" class="text">
    </div>
</template>
<style lang="scss" scoped>
    .pay_fail{
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        .img{
            width: 195px;
            height: 136px;
            margin-bottom: 12px;
            margin-top: 130px;
        }
        .text{
            width: 276px;
            height: 44px;
        }
    }
</style>
<script>
    export default {
        data(){
            return {

            }
        },
        name: 'pay_fail',
        props: {
            msg: String,
            path: String
        },
        methods: {
            name() {
                
            },
        },
    }
</script>


